module.exports = __webpack_public_path__ + "static/img/9.912746b.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/XVC/images/9.png
// module id = jSCL
// module chunks = 4